import { TourConfig } from '../services/tour-guide.service';

export const RETURN_REQUEST_TOUR_CONFIG: TourConfig = {
  id: 'return-request-tour',
  name: 'Guida alle Richieste di Reso',
  steps: [
    {
      id: 'welcome',
      selector: '.main-title',
      title: '👋 Benvenuto nelle Richieste di Reso',
      content: 'Questa guida ti mostrerà come utilizzare la pagina di richiesta di reso: inserire una nuova richiesta e consultare quelle esistenti. Clicca "Avanti" per iniziare.',
      position: 'bottom',
      showNext: true,
      showPrev: false,
      showSkip: true
    },
    // Step 'user-section' e 'company-cards' rimossi: la sezione 1 (Utente e
    // Aziende collegate) è commentata nel template, i selettori #user-section
    // e #company-cards non esistono più nel DOM.
    {
      id: 'form-section',
      selector: '#form-section',
      title: '📝 Form Richiesta di Reso',
      content: 'In questa sezione inserisci i dati della richiesta: codice pallet, dealer, tipo di consegna, stato e altre informazioni utili.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        const component = (window as any).returnRequestComponent;
        if (component && component.isFormCollapsed) {
          component.toggleFormCollapse();
        }
      }
    },
    {
      id: 'form-required',
      selector: '#form-required-fields',
      title: '⚠️ Campi obbligatori',
      content: 'I campi contrassegnati con <strong>*</strong> sono obbligatori. Se non compilati, vedrai un messaggio di errore in rosso al momento dell\'invio.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'form-submit',
      selector: '#form-submit-btn',
      title: '✅ Invia la richiesta',
      content: 'Clicca su <strong>Invia richiesta</strong> per registrare il reso. La nuova richiesta apparirà subito nella tabella sottostante.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'filters-section',
      selector: '#filters-section',
      title: '🔎 Filtri e Azioni',
      content: 'Usa questa sezione per <strong>filtrare le richieste</strong> in tabella per pallet, LDV, dealer, stato, date e altro. Premi "Applica filtri" o "Pulisci filtri" per gestire la selezione.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        const component = (window as any).returnRequestComponent;
        if (component && component.isFiltersCollapsed) {
          component.toggleFiltersCollapsed();
        }
      }
    },
    {
      id: 'requests-list',
      selector: '#requests-list',
      title: '📋 Elenco Richieste',
      content: 'Qui vedi tutte le richieste di reso filtrate. Puoi cercare, filtrare per azienda e impostare il numero di elementi per pagina direttamente nell\'header.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    // Step 'requests-search' rimosso: il campo di ricerca è stato tolto
    // dall'header della sezione richieste.
    {
      id: 'requests-pagination',
      selector: '#requests-pagination',
      title: '📄 Paginazione',
      content: 'Naviga tra le pagine dei risultati. Il contatore "X - Y di Z" indica la posizione corrente nell\'elenco.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    }
  ]
};
